import $ from 'jquery';
import {v$} from './helpers';
import 'webpack-jquery-ui';
import 'jquery-ui-touch-punch';
import {closePopup, openPopup} from './popupForm'

export const draggableInput = (
  parent,
  handleInputsChange,
  gramInput,
  min,
  fixed
) => {
  let input = !!parent ? v$('input[data-grams]', parent)[0] : v$('.js-credits_sum')[0] ;
  let onePageGold = $('.one_page_calc #gold');
  let onePageSilver = $('.one_page_calc #silver');
  let max = input.getAttribute('data-max-value');
  const sliderUI = !!parent ? $('#' + parent.id + ' .input_helper_draggable') : $('.input_helper_draggable');
  const tabsInnerLabel = $(
    '.creditsOneDay-main-right-calc .tabs_inner-label, .main-tabs .tabs_inner-label'
  );
  const handleChange = function(event, ui) {
    const value = parent == null ? ui.value.toFixed(fixed) : ui.value;
    input.value = value;
    let positionDraggableValue = (value / max * 100);
    if (onePageGold) {
      handleInputsChange(!!gramInput ? gramInput : null);
      const handleInput = $('#ui-slider-gold');
      handleInput.css({ right: `${100 - positionDraggableValue}%` });
    }
    if (onePageSilver) {
      handleInputsChange(!!gramInput ? gramInput : null);
      const handleInput = $('#ui-slider-silver');
      handleInput.css({ right: `${100 - positionDraggableValue}%` });
    }
  };
  tabsInnerLabel.eq(0).addClass('active-tab');
  $.widget("ui.slider", $.extend({}, $.ui.slider.prototype, {
    _trimAlignValue: function( val ) {
      if ( val <= this._valueMin() ) {
        return this._valueMin();
      }
      if ( val >= this._valueMax() ) {
        return this._valueMax();
      }
      var step = ( this.options.step > 0 ) ? this.options.step : 1,
        valModStep = ( val - this._valueMin() ) % step,
        alignValue = val - valModStep;

      if ( Math.abs( valModStep ) * 2 >= step ) {
        alignValue += ( valModStep > 0 ) ? step : ( -step );
      }
      // Since JavaScript has problems with large floats, round
      // the final value to 5 digits after the decimal point (see #4124)
      return parseFloat( alignValue.toFixed( 5 ) );
    },
  }));

  const animateDoublePrice = (e) => {
    let doublePrice = $('.double-price-wrap');
    if (doublePrice)
    {
      doublePrice.css('display', 'flex');
      doublePrice.animate({
        opacity: 1,
      }, 800);
    }
  };

  const animatePromoCodes = (e) => {
    let promoGold = $('#promo-gold');
    let promoSilver = $('#promo-silver');
    let promoAppliances = $('#promo-tech');
    let promoWrap = $('.promo-code-wrap');
    if (promoWrap) {
      let appliancesResultTech = v$('#appliances .appliances_result')[0];
      if (e.target.closest('.creditsOneDay-main-right-calc-content')) {
        promoWrap.css('display', 'flex');
        promoWrap.animate({
          opacity: 1,
        }, 800);
        return;
      }
      if (e.target.closest('.tabs_content').getAttribute('id') === "gold") {
        promoGold.css('display', 'flex');
        promoGold.animate({
          opacity: 1,
        }, 800);
      }
      if (e.target.closest('.tabs_content').getAttribute('id') === "silver") {
        promoSilver.css('display', 'flex');
        promoSilver.animate({
          opacity: 1,
        }, 800);
      }
      if (e.target.closest('.tabs_content').getAttribute('id') === "appliances") {
        if (appliancesResultTech.textContent != "0") {
          promoAppliances.css('display', 'flex');
          promoAppliances.animate({
            opacity: 1,
          }, 800);
        }
      }
    }
  }

  const animateOnValueChange = (e) => {
    animateDoublePrice(e);
    animatePromoCodes(e);
  }
  const creditsOneDay = v$('.creditsOneDay')[0];
  const mainTabs = v$('.main-tabs')[0];
  if (creditsOneDay || mainTabs) {
    let techSelectOneDay = v$('#appliances .select select');
    if (techSelectOneDay) {
      techSelectOneDay.forEach( (item) => {
        item.addEventListener('change', animateOnValueChange);
      })
    }
  }

  const range = sliderUI.slider({
    min,
    max,
    step: 0.01,
    start: animateOnValueChange,
    change: handleChange,
    slide: handleChange
  });
  input.addEventListener('input', (e) => {
    let data = input.value.split('.');
    if(data.length > 2) {
      input.value = data.splice(0, data.length - 1).join('.');
    }
    input.value = input.value.replace(',', '.');
    const tab = tabsInnerLabel.eq(0).hasClass('active-tab')
      ? 'gold'
      : tabsInnerLabel.eq(1).hasClass('active-tab')
        ? 'silver'
        : 'gold';
    switch(tab){
      case 'gold':
        if(input.value.split('.').length === 1 || input.value.split('.')[1] !== '') {
          range.slider('value', input.value);
        }
        break;
      case 'silver':
        let inputSilver = $('#gram_input_silver');
        if(input.value.split('.').length === 1 || input.value.split('.')[1] !== '') {
        range.slider('value', inputSilver.val());
        }
        break;
    }
    animateOnValueChange(e);
  });

  const inputOnLoad = () => {
    let promoWrap = $('.promo-code-wrap');
      if (tabsInnerLabel.eq(0).hasClass('active-tab') || onePageGold.length !== 0) {
        const gramInputGold = $('#gram_input_gold');
        let baseGoldValue = gramInputGold.val();
        $('#gold .input_helper_draggable').slider("value", baseGoldValue);
        if (promoWrap.length > 0) {
          let inputPromoType = document.querySelector('#type');
          let parentOneDay = v$('#gold')[0];
          inputPromoType.value = parentOneDay.getAttribute('id');
          $('.promo-code-wrap').css({'display': 'none', 'opacity': '0'});
        }
      }
      if (tabsInnerLabel.eq(1).hasClass('active-tab') || onePageSilver.length !== 0) {
        const gramInputSilver = $('#gram_input_silver');
        let baseSilverValue = gramInputSilver.val();
        $('#silver .input_helper_draggable').slider("value", baseSilverValue);
        if (promoWrap.length > 0) {
          let inputPromoType = document.querySelector('#type');
          let parentOneDay = v$('#silver')[0];
          inputPromoType.value = parentOneDay.getAttribute('id');
          $('.promo-code-wrap').css({'display': 'none', 'opacity': '0'});
        }
      }
      if (tabsInnerLabel.eq(2).hasClass('active-tab')) {
        // let parentOneDay = v$('#appliances')[0];
        // inputPromoType.value = parentOneDay.getAttribute('id');
        if (promoWrap.length > 0) {
        let inputPromoType = document.querySelector('#type');
        inputPromoType.value = "tech";
        $('.promo-code-wrap').css({'display': 'none', 'opacity': '0'});
        }
      }
  }
  document.addEventListener('DOMContentLoaded', inputOnLoad);

  tabsInnerLabel.on('click', function(e) {
    tabsInnerLabel.removeClass('active-tab');
    $(e.target).toggleClass('active-tab');
    inputOnLoad();
  });
};

export const draggableInputFocus = () => {
  let inputHelper = $('.input_helper_draggable .ui-state-default');
  let input = $('.tabs_content-inner input');
  let creditsInput = $('.js-credits_sum');

  inputHelper.on('focus', function() {
    $('.tabs_content .ui-slider-range').addClass('draggable-bg');
  });

  inputHelper.on('blur', function() {
    $('.tabs_content .ui-slider-range').removeClass('draggable-bg');
  });

  input.on('focus', function() {
    $('.tabs_content .ui-slider-handle').addClass('red-icon');
    $('.tabs_content .ui-slider-range').addClass('draggable-bg');
  });

  input.on('blur', function() {
    $('.tabs_content .ui-slider-handle').removeClass('red-icon');
    $('.tabs_content .ui-slider-range').removeClass('draggable-bg');
  });

  creditsInput.on('focus', function() {
    $('.tabs_content .ui-slider-handle').addClass('red-icon');
    $('.tabs_content .ui-slider-range').addClass('draggable-bg');
  });

  creditsInput.on('blur', function() {
    $('.tabs_content .ui-slider-handle').removeClass('red-icon');
    $('.tabs_content .ui-slider-range').removeClass('draggable-bg');
  });
}

//MAIN PROMO OPEN
const openPromoCodePopup = () => {
  const promoCodeLink = v$('.promo-code-text'),
    promoPopUp = v$('#promo')[0],
    promoPopUpClose = v$('#promo .popup-close')[0],
    promoCodeWrap = v$('.promo-code-wrap')[0],
    promoSubmit = v$('#promo .btn')[0],
    creditsOneDayPromo = v$('#promo-one-day')[0],
    mainTabs = v$('.main-tabs')[0];

    if (promoCodeWrap) {
      promoCodeLink.forEach( (item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          openPopup(promoPopUp);
          promoSubmit.setAttribute('id', item.getAttribute('id') + '-submit');
        })
      })

      promoPopUpClose.addEventListener('click', (e) => {
        e.preventDefault();
        closePopup(promoPopUp);
      })
      if (creditsOneDayPromo) {
        promoCodeLink.forEach( (item) => {
          let changeId = item.getAttribute('id').replace(/promo/g, "credits-one-day-promo");
          item.setAttribute('id', changeId);
        })
      }
      if (mainTabs) {
        promoCodeLink.forEach( (item) => {
          let changeId = item.getAttribute('id').replace(/promo/g, "main-promo");
          item.setAttribute('id', changeId);
        })
      }
    }
}
openPromoCodePopup();

